import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const exportLicenseStatusEnum = createEnum({
    PENDING: ['pending', '待办理', 'default'],
    PROCESSING: ['processing', '办理中', 'processing'],
    HANDLED: ['handled', '已办理', 'success'],
});
export const EXPORT_LICENSE_STATUSES = enumValues(exportLicenseStatusEnum);
export const EXPORT_LICENSE_STATUS_LABEL_MAP = enumLabelMap(exportLicenseStatusEnum);
//# sourceMappingURL=export-license.js.map